/** var(--green4) */
export const POSITIVE_COLOR = '#00bc8a';

/** var(--red3) */
export const NEGATIVE_COLOR = '#ee3f3f';
